import styled from "styled-components";

const Tabs = (props) => {
    const { tabValue, handleTabValue, tabOptions } = props;
    return (
        <Container>
            {tabOptions.map((option) => (
                <Tab
                    onClick={() => handleTabValue(option.id)}
                    tabValue={tabValue}
                    key={option.id}
                    active={tabValue === option.id}
                >
                    {option.label}
                </Tab>
            ))}
        </Container>
    )
}

export default Tabs;

const Container = styled.div`
    width: fit-content;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 1rem;
`

const Tab = styled.button`
    position: relative;
    padding: 10px 25px;
    cursor: pointer;
    color: ${(props) => (props.active ? '#b31d15' : '#535353')};
    font-size: 16px;
    font-weight: ${(props) => (props.active ? '700' : '400')};
    transition: color 0.3s;
    background-color: ${(props) => (props.active ? '#fff' : 'transparent')};
    box-shadow: ${(props) => (props.active ? '0px 4px 4px -2px #18274B14, 0px 2px 4px -2px #18274B1F' : 'none')};
    border-radius: 100px;
`